<template>
  <container>
    <div class="row">
      <div class="col-12 col-md-10 col-lg-8">
        <h2>Главные блоки</h2>
        <ul class="interface">
          <li
            :style="{
              maxWidth: block.width * device * 25 + '%',
            }"
            v-for="block in blocks"
            :key="block.id"
          >
            <div
              :style="{
                paddingTop: (block.height / block.width) * 100 + '%',
              }"
            >
              <ul class="subinterface">
                <li
                  :style="{
                    maxWidth: item.width * 50 + '%',
                  }"
                  v-for="item in block.child"
                  :key="item.id"
                >
                  <div
                    :style="{
                      paddingTop: (item.height / item.width) * 100 + '%',
                    }"
                  >
                    <a>
                      <img
                        :alt="'New Collection'"
                        :title="'New Collection'"
                        :src="item.img"
                      />
                    </a>
                  </div>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </container>
</template>

<script>
export default {
  mounted() {
    this.device = window.innerWidth <= 800 ? 2 : 1;
    window.addEventListener("resize", () => {
      this.device = window.innerWidth <= 800 ? 2 : 1;
    });
  },
  data: () => ({
    device: 1,
    blocks: [
      {
        id: 1,
        width: 2,
        height: 1,
        child: [
          {
            id: 1,
            path: "/catalog/jenskaya-odejda",
            img: "https://api.seven.rrpo.uz/storage/home/1.jpg",
            img_placeholder: "https://api.seven.rrpo.uz/loading.jpg",
            width: 2,
            height: 1,
          },
        ],
      },
      {
        id: 2,
        width: 2,
        height: 1,
        child: [
          {
            id: 1,
            path: "/catalog/mujskaya-odejda",
            img: "https://api.seven.rrpo.uz/storage/home/2.jpg",
            img_placeholder: "https://api.seven.rrpo.uz/loading.jpg",
            width: 2,
            height: 1,
          },
        ],
      },
      {
        id: 3,
        width: 2,
        height: 2,
        child: [
          {
            id: 1,
            path: "/catalog/jenskaya-odejda/new-collection",
            img: "https://api.seven.rrpo.uz/storage/home/1.png",
            img_placeholder: "https://api.seven.rrpo.uz/loading.jpg",
            width: 2,
            height: 2,
          },
        ],
      },
      {
        id: 4,
        width: 2,
        height: 2,
        child: [
          {
            id: 1,
            path: "/catalog/mujskaya-odejda/sales",
            img: "https://api.seven.rrpo.uz/storage/home/3.jpg",
            img_placeholder: "https://api.seven.rrpo.uz/loading.jpg",
            width: 2,
            height: 1,
          },
          {
            id: 2,
            path: "/catalog/deti",
            img: "https://api.seven.rrpo.uz/storage/home/5.jpg?v2=1",
            img_placeholder: "https://api.seven.rrpo.uz/loading.jpg",
            width: 2,
            height: 1,
          },
        ],
      },
    ],
  }),
};
</script>

<style lang="scss">
ul.interface {

  display: flex;
  flex-flow: wrap;
  justify-content: flex-end;
  list-style: none;
  margin-right: -7.5px;
  margin-left: -7.5px;

  & > li {
    padding-right: 7.5px;
    padding-left: 7.5px;
    margin-bottom: 15px;
    position: relative;
    width: 100%;
    overflow: hidden;
    & > div {
      height: 0;
      ul.subinterface {
        margin-right: -7.5px;
        margin-left: -7.5px;
        display: flex;
        flex-flow: wrap;
        justify-content: flex-end;
        list-style: none;
        position: absolute;
        bottom: 0;
        top: 0;
        width: 100%;
        height: 100%;
        overflow: hidden;
        & > li {
          margin-top: 0;
          margin-bottom: 15px;
          padding-right: 7.5px;
          padding-left: 7.5px;
          width: 100%;
          position: relative;
          & > div {
            height: 0;
            width: 100%;
            background: #ebebeb;
            position: relative;

            & > a {
              & > img {
                position: absolute;
                left: 0;
                right: 0;
                bottom: 0;
                top: 0;
                width: 100%;
                height: 100%;
                object-fit: cover;
              }
            }
          }
        }
      }
    }
  }
}
</style>